/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
	selector: "cb-dot",

	imports: [CommonModule],
	templateUrl: "./dot.component.html",
	styleUrl: "./dot.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotComponent {
	public readonly size = input<"sm" | "md" | "lg">("sm");

	public readonly color = input<
		| "mapped"
		| "auto"
		| "brand"
		| "gray"
		| "error"
		| "warning"
		| "success"
		| "info"
		| "custom"
		| "pink"
		| "dark-orange"
		| "green"
		| "rose"
	>("brand");

	public readonly customColor = input<string>();

	public readonly outline = input(false);

	// TODO ANIMATE OUTLINE
}
